<template>
	<router-view :key="$route.path"></router-view>
</template>
